import { IState } from 'services/root-reducer';
import { createOperation } from 'services/operations/operations-reducer';
import { WithOptionalState } from './with-optional-state';

export const getOperation = WithOptionalState(
    (state: IState, id: string) => (
        !state.operations[id]
            ? null
            : state.operations[id]
    )
);

export const getOperationSafe = WithOptionalState(
    (state: IState, id: string) => {
        const defaultOperation = createOperation(id);
        return !state.operations[id] ? defaultOperation : state.operations[id];
    }
);

export const getOperationData = WithOptionalState(
    (state: IState, id: string) => {
        if (state.operations[id]) {
            return state.operations[id].data;
        }
        return null;
    }
);

export const getOperationStatus = WithOptionalState(
    (state: IState, id: string) => {
        if (state.operations[id]) {
            return state.operations[id].status;
        }
        return null;
    }
);

export const getMapState = WithOptionalState(
    (state: IState) => state.operations.MAP_STATE.data
);

export const getFavorites = WithOptionalState(
    (state: IState) => state.favorites.items
);

export const getContainerFilters = WithOptionalState(
    (state: IState, containerCode: string, with_custom_filters = false) => {
        let filters = state.operations.FILTERS.data[containerCode] || [];
        if (with_custom_filters) {
            return filters;
        } else {
            return filters.filter(f => !f.is_custom);
        }
    }
);

export const getAuthToken = WithOptionalState(
    (state: IState) => state.app.authToken
);

export const getAppState = WithOptionalState(
    (state: IState) => state.app
);

export * from './omjs';
export * from './objects';
export * from './containers';
